import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

type IconProps = {
    size?: SizeProp;
    icon : IconProp;
    cor?: string;
}

export const Icone = ({size, icon, cor}: IconProps) => {
   return <FontAwesomeIcon icon={icon} size={size} color={cor}/>
}